import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { TaskTodo } from 'crono-fe-common/types/cronoTaskTodo';
import { toQueryString } from 'utils/queryClient';

export interface UseGetTaskParams {
  id: number;
  withLog?: boolean;
  withProspect?: boolean;
  withAccount?: boolean;
  withOpportunity?: boolean;
  withTemplate?: boolean;
}

export default function useGetTask() {
  const getTask = (params: UseGetTaskParams) => {
    const { id, ...optionalParams } = params;

    const queryParams = toQueryString(optionalParams);

    const request: Request = {
      url: `${ENDPOINTS.task.main}/${id}?${queryParams}`,
      config: {
        method: 'GET',
      },
    };

    return client(request);
  };

  return useMutation<Response<TaskTodo>, CronoError, UseGetTaskParams>(getTask);
}
